 function checkCartContents() {
   event.preventDefault();

  // Make the GET request to the cart endpoint
  fetch(`/cart.js`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => {
      // Check if the response is okay (status 200)
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      // Parse the JSON response
      return response.json();
    })
    .then(cartData => {
      // Process the cart data
      processCartData(cartData.items);
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
    });
}


// Function to process cart data
function processCartData(items) {
  var formData = new FormData();
  let matchFound = 'false';
  
  // First loop: collect all additional product keys
  items.forEach(item => {
    if (item.properties && item.properties._additional_product) {
      const groupKey = item.properties._additional_product.split(':')[1];
      
      let matchFound = 'false';

      //look through all items without an _additional_product property and make sure there is a match
      items.forEach(item2 => {
        if (item2.properties && !item2.properties._additional_product && item2.properties._main_group_key) {
       
          if (item2.properties._main_group_key === groupKey){
            matchFound = 'true';
          }
             
        }
      });

      if (matchFound != 'true'){
        //console.log("Removing:" + item.key);
      formData.append("updates["+item.key+"]", 0);
        
    }
    }


    
  });

  fetch(window.Shopify.routes.root + 'cart/update.js', {
  method: 'POST',
  body: formData
})
.then(response => response.json())
.then(data => window.location.href = '/checkout');

}